// import { connect } from 'socket.io-client';
import { createContext, useContext } from 'react';

// import { BASE_URL } from '../../config';

// Socket.IO is disabled - create a mock socket object
const createMockSocket = () => {
  const mockSocket = {
    emit: (_event?: string, _data?: unknown) => mockSocket,
    on: (_event: string, _callback?: (data: unknown) => void) => mockSocket,
    off: (_event?: string, _callback?: (data: unknown) => void) => mockSocket,
    disconnect: () => mockSocket,
    connect: () => mockSocket,
    connected: false,
    disconnected: true,
  };
  return mockSocket;
};

// const url = BASE_URL?.replace('/api','') || '';
// const socket = connect(url, {
//   path: '/socket.io',
//   transports: ['websocket'],
// });

const socket = createMockSocket();

export const SocketContext = createContext(socket);

export const useSocket = () => {
  const s = useContext<typeof socket>(SocketContext);
  if (!s) {
    // Return mock socket instead of throwing error
    return createMockSocket();
  }

  return s;
};
